import has from "lodash/has";
import { useRotaAgenciesStore } from "../rotaagencies";
import { useRotaUsersStore } from "../rotausers";

const API_NAME = "rota";
const API_VERSION = "/v1";
const CONTENT_TYPE = "application/vnd.coactive.rota-agency+json";

const modulestate = () => ({
  // The state must return a function to make the module reusable.
});
const mutations = {};

const actions = {
  async getRotaAgency(context, params) {
    // the 'get agency' (singular) API endpoint returns the same data as the get agencies endpoint,
    // so we can use the cached data for speed
    const piniaStore = useRotaAgenciesStore();
    const agencies = await piniaStore.getRotaAgenciesForAgencySelection();
    // search agencies
    const agency = agencies.find((a) => a.id === params.id);
    if (agency) {
      return agency;
    }
    if (params?.options?.doNotCatchIfError) {
      this.$api.doNotCatchIfError();
    }
    // if not found, fallback to fetch from API
    return this.$api.get(API_NAME, `${API_VERSION}/rota-agencies/${params.id}`);
  },

  async getRotaAgencies(context, payload) {
    const myInit = {};
    // payload contains filter/sort options.
    if (payload) {
      myInit.queryStringParameters = {};
      if (has(payload, "sortBy")) {
        let sortField = payload.sortBy;
        if (sortField === "dateCreated") {
          sortField = "_id";
        }
        let sortOrder = 1;
        if (has(payload, "sortDesc") && payload.sortDesc === true) {
          sortOrder = -1;
        }
        myInit.queryStringParameters.sort = JSON.stringify({
          [sortField]: sortOrder,
        });
      }

      if (has(payload, "filter")) {
        myInit.queryStringParameters.filter = JSON.stringify(payload.filter);
      }

      if (has(payload, "archived")) {
        myInit.queryStringParameters.archived = payload.archived;
      }
    }
    return this.$api
      .get(API_NAME, `${API_VERSION}/rota-agencies`, myInit)
      .then((response) => {
        if (has(response, "_embedded.rota-agencies")) {
          return response;
        }
        return false;
      });
  },
  /**
   * Cached endpoint to get rota agencies for use within select dropdowns
   * @param {*} context
   * @returns []
   */
  async getRotaAgenciesForAgencySelection() {
    const piniaStore = useRotaAgenciesStore();
    return piniaStore.getRotaAgenciesForAgencySelection();
  },
  async createRotaAgency(context, rotaAgency) {
    const myInit = {
      headers: {
        Accept: CONTENT_TYPE,
      },
      body: rotaAgency,
    };
    const piniaStore = useRotaUsersStore();
    piniaStore.localStorageInvalidateCache("getRotaAgenciesForAgencySelection");
    return this.$api.post(API_NAME, `${API_VERSION}/rota-agencies`, myInit);
  },
  async updateRotaAgency(context, params) {
    const myInit = {
      headers: {
        Accept: CONTENT_TYPE,
      },
      body: params.changes,
    };
    const piniaStore = useRotaUsersStore();
    piniaStore.localStorageInvalidateCache("getRotaAgenciesForAgencySelection");
    return this.$api.patch(
      API_NAME,
      `${API_VERSION}/rota-agencies/${params.id}`,
      myInit,
    );
  },
  async archiveRotaAgency(context, params) {
    const myInit = {
      headers: {
        Accept: CONTENT_TYPE,
      },
    };
    const piniaStore = useRotaUsersStore();
    piniaStore.localStorageInvalidateCache("getRotaAgenciesForAgencySelection");
    return this.$api.post(
      API_NAME,
      `${API_VERSION}/rota-agencies/${params.id}/archive`,
      myInit,
    );
  },
  async latestAuthEvents(context, payload) {
    const api = this.$api;
    if (payload.doNotCatchIfError) {
      api.doNotCatchIfError();

      delete payload.doNotCatchIfError;
    }
    const myInit = {
      queryStringParameters: {
        ...payload,
      },
    };
    return this.$api.get(
      API_NAME,
      `${API_VERSION}/stats/rota-agencies/auth-events/latest-with-shifts`,
      myInit,
    );
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state: modulestate,
};
